import { getItemReferenceType } from "./Layout";
export function itemReferenceValidation({ itemReference }) {
    const itemRefType = getItemReferenceType(itemReference);
    if (itemRefType === "vector") {
        return { status: "pass" };
    }
    return { status: "fail", error: "This itemreference is rendered on the server" };
}
//# sourceMappingURL=Validation.js.map